import React from 'react';
import PropTypes from 'prop-types';
import messages from './messages';

import { Row, Col } from 'reactstrap';
import { Icon } from 'antd';
import List from './items';
import {default as PlaceholderListItem} from '../Placeholders/ListItem';

import './style.scss';
import 'antComponentsStyle';

class InteractiveList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showAll: false,
    };
    this.handleOnShowAllClick = this.handleOnShowAllClick.bind(this);
  }

  handleOnShowAllClick() {
    this.setState({ showAll: !this.state.showAll });
  }


  render() {
    const { title, withBorder, withPlaceholder, limit, items, itemCallback, removeAllCallback } = this.props;
    const { showAll } = this.state;

    const className = "Interactive-List";

    const hasItems = items.length > false;
    const hasManyItems = items.length > limit;

    let visibleItems = [...items];
    if ( !showAll )
      visibleItems = visibleItems.splice(0, limit );


    return (
      <div className={ withBorder ? `${className} with-border` : className }>
        {title &&
          <h6>{title}</h6>
        }
        <Row className={'no-gutters'}>
          <Col>
            {
              hasItems &&
              <List
                items={visibleItems}
                showButton={hasManyItems}
                showAll={showAll}
                onShowClick={this.handleOnShowAllClick}
                itemCallback={itemCallback}
              />
            }
            {
              !hasItems && withPlaceholder &&
              <PlaceholderListItem
              title={messages.placeholderTitle.defaultMessage}
              description={messages.placeholderDescription.defaultMessage}
              />
            }
          </Col>
        </Row>
      </div>
    );
  }
}


InteractiveList.defaultProps = {
  withBorder: true,
  withPlaceholder: true,
  limit: 3,
  items: [],
  itemCallback: () => {},
  removeAllCallback: () => {},
};

InteractiveList.propTypes = {
  withBorder: PropTypes.bool,
  withPlaceholder: PropTypes.bool,
  limit: PropTypes.number,
  itemCallback: PropTypes.func,
  removeAllCallback: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.shape({
      price: PropTypes.number.isRequired,
      code: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      short_description: PropTypes.string,
      standard_description: PropTypes.string,
  })),
};

export default InteractiveList;
